var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M265.5,77.5c42.5,0,74.5,32,74.5,74.5c0,19.8-7.6,38.4-21.5,52.5c-14,14.2-32.8,22-53,22c-19.5,0-38-7.9-52.3-22.2 C198.8,190,191,171.5,191,152c0-20.2,7.8-39,22-53C227,85.1,245.7,77.5,265.5,77.5 M363.5,304.4c15.3,0,29,7.3,33.4,17.9 l43.1,112.2H72.1l43.1-112.2c4.4-10.5,18.1-17.9,33.4-17.9H363.5 M265.5,48c-56.5,0-104,45.2-104,104c0,56.5,47.5,104,104,104 c58.8,0,104-47.5,104-104C369.5,93.2,324.2,48,265.5,48L265.5,48z M363.5,274.9h-215c-28.2,0-52.1,15-60.8,36.5L29.1,464h453.8 l-58.6-152.6C415.6,290,391.7,274.9,363.5,274.9L363.5,274.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.9606ca40f40f5ccf132a187921c6f0b2.svg";
export { ForwardRef as ReactComponent };